module.exports = __webpack_public_path__ + "static/media/nbc-uni-logo.7b7c96a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/nbc-uni-logo.png
// module id = 690
// module chunks = 0